import {createImageObject} from '../utils';
import {merge, flatten, cloneDeep} from 'lodash';
import {MIN_IMAGE_INPUT_SIZE, MIN_IMAGE_RATIO, MAX_IMAGE_RATIO, MAX_IMAGE_INPUT_SIZE} from '@/views/Image/crop/config';

const VERTICAL = 'vertical';
const HORIZONTAL = 'horizontal';
const AUTOSIZE = 'autoSize';
const FIXEDRATIO = 'fixedRatio';
const SMARTCROPTYPE = 'smart';
const AVERAGECROPTYPE = 'average';
function checkSmartFrom(form) {
    const {sizeType} = form;
    const formData = form[sizeType];
    const {ratio, size, width, height} = formData;
    if (sizeType === FIXEDRATIO) {
        if (!ratio || !size) {
            return false;
        }
        const submitSize = size.split('*').map(item => Number(item));
        return {
            ratio,
            width: submitSize[0],
            height: submitSize[1]
        };
    }
    if (sizeType === AUTOSIZE) {
        if (
            !width || !height
            || width <= MIN_IMAGE_INPUT_SIZE || height <= MIN_IMAGE_INPUT_SIZE
            || width > MAX_IMAGE_INPUT_SIZE || height > MAX_IMAGE_INPUT_SIZE
            || width / height < MIN_IMAGE_RATIO || width / height > MAX_IMAGE_RATIO
        ) {
            return false;
        }
        return {
            width: Number(width),
            height: Number(height)
        };
    }
    return false;
}
function checkAverageForm(form) {
    const {cropDirection, sliderValue} = form;
    let verticalNumber = 1;
    let horizontalNumber = 1;
    if (cropDirection[VERTICAL]) {
        verticalNumber = sliderValue[VERTICAL];
    }
    if (cropDirection[HORIZONTAL]) {
        horizontalNumber = sliderValue[HORIZONTAL];
    }
    if (verticalNumber > 1 || horizontalNumber > 1) {
        return {
            verticalNumber,
            horizontalNumber
        };
    }
    return false;
}
function formatAverageParams({verticalNumber, horizontalNumber}, imageList) {
    if (!verticalNumber || !horizontalNumber || !imageList || !imageList.length) {
        return [];
    }
    return flatten(imageList.map(item => getCropParams(verticalNumber, horizontalNumber, item)));
}
function formatSmartParams({width, height}, imageList) {
    if (!width || !height || !imageList || !imageList.length) {
        return [];
    }
    const submitImageList = imageList.map(item => {
        return {
            url: item.url,
            width: item.width,
            height: item.height
        };
    });
    return {
        imageList: submitImageList,
        width,
        height,
        retMode: 'url'
    };
}
function getCropParams(verticalNumber, horizontalNumber, {url: imageUrl, width: imageWidth, height: imageHeight}) {
    let offsetWidth = parseInt(imageWidth / verticalNumber, 10);
    let offsetHeight = parseInt(imageHeight / horizontalNumber, 10);
    const verticalList = Array(verticalNumber).fill(1).map((_, index) => index);
    const horizontalList = Array(horizontalNumber).fill(1).map((_, index) => index);
    let offsetY = 0;
    let targetSizes = horizontalList.map(y => {
        offsetY = offsetHeight * y;
        return verticalList.map(x => {
            return {
                offsetX: offsetWidth * x,
                offsetY,
                offsetWidth,
                offsetHeight,
                width: offsetWidth,
                height: offsetHeight
            };
        });
    });
    targetSizes = flatten(targetSizes);
    const defaultParams = {
        productLine: 'CHUANGYIGUAN',
        needMola: false,
        addCropImage: false,
        imageUrl,
        imageWidth,
        imageHeight,
        cropStrategy: 'CROP_CUSTOM'
    };
    let submitParamList = [{
        ...defaultParams,
        targetSizes: targetSizes
    }];
    const len = targetSizes.length;
    if (len > 5) {
        let newList = [];
        let sliceNumbers = Array(Math.ceil(targetSizes.length / 5)).fill(1).map((_, index) => index);
        sliceNumbers.forEach(i => {
            newList.push({
                ...defaultParams,
                targetSizes: targetSizes.slice(i * 5, Math.min((i + 1) * 5), len)
            });
        });
        submitParamList = newList;
    }
    return submitParamList;
}

const defaultState = {
    title: '智能裁图',
    VERTICAL,
    HORIZONTAL,
    AUTOSIZE,
    FIXEDRATIO,
    SMARTCROPTYPE,
    AVERAGECROPTYPE,
    uploadImg: [],
    displayImg: [],
    recordImg: [],
    editLoading: false,
    toolBarLoading: false,
    suggestImg: [{
        url: 'https://feed-image.baidu.com/0/pic/-677173041_1768763072_-970901219.jpg',
        width: 2048,
        height: 1365
    }, {
        url: 'https://feed-image.baidu.com/0/pic/327114197_1582000405_-1628271697.jpg',
        width: 2048,
        height: 1365
    }, {
        url: 'https://feed-image.baidu.com/0/pic/1599803316_-340761796_-1150279700.jpg',
        width: 2048,
        height: 1365
    }],
    historyParams: {
        pageNo: 1,
        pageSize: 10,
        taskType: [11]
    },
    pageLoadingStatus: {
        show: false,
        title: ''
    },
    // cropFrom data
    cropFormData: {
        cropType: SMARTCROPTYPE, // smart, average
        [SMARTCROPTYPE]: {
            sizeType: FIXEDRATIO, // autoSize, fixedRatio
            [FIXEDRATIO]: {
                ratio: '1:1',
                size: '600*600'
            },
            [AUTOSIZE]: {
                width: null,
                height: null
            }
        },
        [AVERAGECROPTYPE]: {
            // cropDirection: VERTICAL, // 等分裁切方向，horizontal, vertical
            cropDirection: {
                [VERTICAL]: true,
                [HORIZONTAL]: false
            },
            sliderValue: {
                [VERTICAL]: 2, // 等分裁切份数 2-5
                [HORIZONTAL]: 2
            }
        }
    },
    canSubmit: false,
    submitForm: {}
};
export default {
    namespaced: true,
    state: cloneDeep(defaultState),
    mutations: {
        CHANGE_UPLOAD_IMG(state, data) {
            state.uploadImg = data;
        },
        CHANGE_RECORD_IMG(state, data) {
            state.recordImg = data;
        },
        CHANGE_DISPLAY_IMG(state, data) {
            state.displayImg = data;
        },
        CHANGE_EDIT_LOADING(state, data) {
            state.editLoading = data;
        },
        CHANGE_TOOLBAR_LOADING(state, data) {
            state.toolBarLoading = data;
        },
        CHANGE_PAGE_STATUS(state, data) {
            state.pageLoadingStatus = data;
        },
        CHANGE_CROP_FORM_DATA(state, data) {
            state.cropFormData = merge(state.cropFormData, data);
        },
        CHANGE_VALID_STATUS(state, val) {
            state.canSubmit = val;
        },
        CHANGE_SUBMIT_FORM(state, data) {
            state.submitForm = data;
        },
        RESET_STATE(state) {
            Object.entries(cloneDeep(defaultState)).forEach(([key, val]) => {
                state[key] = val;
            });
        }
    },
    actions: {
        changeUploadImg({dispatch, commit}, data) {
            commit('CHANGE_UPLOAD_IMG', data);
            dispatch('changeValidStatus');
        },
        changeDisplayImg({commit}, data) {
            commit('CHANGE_DISPLAY_IMG', data);
        },
        changePageStatus({commit}, data) {
            commit('CHANGE_PAGE_STATUS', data);
        },
        // 更改cropForm数据
        changeFormData({dispatch, commit}, data) {
            commit('CHANGE_CROP_FORM_DATA', data);
            dispatch('changeValidStatus');
        },
        resetState({commit}) {
            commit('RESET_STATE');
        },
        changeValidStatus({commit, state}) {
            const {cropFormData, uploadImg} = state;
            if (uploadImg.length < 1) {
                commit('CHANGE_VALID_STATUS', false);
                return;
            }
            const cropType = cropFormData.cropType;
            const cropForm = cropFormData[cropType];
            let checkRes = false;
            if (cropType === SMARTCROPTYPE) {
                checkRes = checkSmartFrom(cropForm);
            }
            else if (cropType === AVERAGECROPTYPE) {
                checkRes = checkAverageForm(cropForm);
            }
            commit('CHANGE_VALID_STATUS', !!checkRes);
            checkRes && commit('CHANGE_SUBMIT_FORM', {
                cropType,
                ...checkRes
            });
        },
        // 获取创作纪录
        async getHistory({commit, state}, model) {
            try {
                const res = await model.imageCreate.getHistory(state.historyParams);
                const recordImgList = res.listData.map(i => {
                    let recordList = i.records;
                    try {
                        const record = recordList[0];
                        const {cropType} = JSON.parse(record.ext);
                        // 精简裁图无需展示手动裁图功能
                        if (cropType === 'simplyCropImage') {
                            recordList = recordList.map(item => {
                                item.noCropOut = true;
                                return item;
                            });
                        }
                    }
                    catch (err) {
                        console.log(err);
                    }
                    return recordList;
                }).filter(item => item !== undefined);

                commit('CHANGE_RECORD_IMG', recordImgList);
            }
            catch (err) {
                throw err;
            }
        },
        // 图片上传 获取主体
        async handleImagePickerConfirm({dispatch, commit, state}, info) {
            const {model, res} = info;
            const imgRes = res?.data?.[0]?.[0] || [];
            const uploadImg = imgRes.map(item => ({
                url: item.url,
                width: item.width,
                height: item.height
            }));
            const allUploadImg = state.uploadImg.concat(uploadImg);
            dispatch('changeUploadImg', allUploadImg);
        },
        // 裁图按钮提交
        async handleCropSubmit({commit, state}, model) {
            commit('CHANGE_TOOLBAR_LOADING', true);
            try {
                const {uploadImg, submitForm} = state;

                let params = {};
                let displayImg = [];
                if (submitForm.cropType === SMARTCROPTYPE) {
                    params = {
                        ...formatSmartParams(submitForm, uploadImg),
                        imageGenerateType: 'SIMPLE_AUTO_CROP_MODEL'
                    };
                    const baseDisplayImg = params.imageList.map((_, index) => {
                        return {...createImageObject({recordId: index}), taskId: -1};
                    });
                    commit('CHANGE_DISPLAY_IMG', baseDisplayImg);
                    const data = await model.imageCreate.cropImageSmart(params);
                    displayImg = data.map(img => {
                        return {
                            ...img,
                            ...createImageObject({
                                url: img.url,
                                recordId: img.recordId,
                                width: img.width,
                                height: img.height
                            }),
                            ratio: submitForm.ratio
                        };
                    });
                }
                else if (submitForm.cropType === AVERAGECROPTYPE) {
                    params = {
                        cropImageList: formatAverageParams(submitForm, uploadImg),
                        imageGenerateType: 'SIMPLE_AUTO_CROP_MODEL'
                    };
                    const baseDisplayImg = params.cropImageList.reduce((prev, cur) => prev.concat(cur.targetSizes), [])
                                            .map((_, index) => {
                                                return {...createImageObject({recordId: index}), taskId: -1};
                                            });
                    commit('CHANGE_DISPLAY_IMG', baseDisplayImg);
                    const data = await model.imageCreate.cropImageAverage(params);
                    let resultList = [];
                    data.forEach(item => {
                        const newList = item.cropImageList.map(img => {
                            img.orgUrl = item.orgUrl;
                            img.orgWidth = item.width;
                            img.orgHeight = item.height;
                            return img;
                        });
                        resultList = resultList.concat(newList);
                    });
                    displayImg = resultList.map(img => {
                        return {
                            ...img,
                            ...createImageObject({
                                url: img.url,
                                recordId: img.recordId,
                                width: img.width,
                                height: img.height
                            }),
                            noCropOut: true
                        };
                    });
                }
                commit('CHANGE_DISPLAY_IMG', displayImg);
            }
            catch (err) {
                console.error(err.message);
                throw err;
            }
            finally {
                commit('CHANGE_TOOLBAR_LOADING', false);
            }
        }
    }
};